/** `payable_entry.kind`. The sign of `amount_minor` is fixed per kind by the `payable_entry_sign` CHECK. */
export const PAYABLE_ENTRY_KIND = [
    "payment_captured",
    "refund",
    "refund_returned",
    "dispute_opened",
    "dispute_reversed",
    "payout",
    "payout_returned",
    "adjustment",
    "processor_fee",
    "commission",
];
/** Kinds whose `amount_minor` is always positive (WeTalk owes more). */
export const PAYABLE_CREDIT_KIND = ["payment_captured", "refund_returned", "dispute_reversed", "payout_returned"];
/** Kinds whose `amount_minor` is always negative (WeTalk owes less). `adjustment` is either, never zero. */
export const PAYABLE_DEBIT_KIND = ["refund", "dispute_opened", "payout", "processor_fee", "commission"];
/** `payout.state`. Created by one operator, approved by another (maker/checker, D5). */
export const PAYOUT_STATE = ["created", "approved", "sent", "settled", "failed", "cancelled"];
/** `payout_run.state`. At most one run is `created` or `approved` at a time. */
export const PAYOUT_RUN_STATE = ["created", "approved", "closed", "cancelled"];
/** `collection_exception.kind` — 0040's list verbatim (0038's, plus `amount_mismatch_movement`). */
export const COLLECTION_EXCEPTION_KIND = [
    "unattributed_webhook",
    "unmatched_provider_payment",
    "amount_mismatch",
    "payment_link_unresolved",
    "refund_unresolved",
    "refund_failed",
    "late_payment_refunded",
    "double_settlement",
    "settlement_difference",
    "safeguarding_violation",
    "safeguarding_shortfall",
    "float_low",
    "dispute_opened",
    "dispute_undecided",
    "amount_mismatch_movement",
];
export const COLLECTION_EXCEPTION_STATE = ["open", "resolved"];
/** `collection_funding.kind` — the float's movements (OD-M9). */
export const COLLECTION_FUNDING_KIND = ["top_up", "withdrawal"];
/** `collection_cost.kind` — costs WeTalk bears (OD-M2 (c), OD-M8). */
export const COLLECTION_COST_KIND = ["processor_fee", "dispute_fee", "refund_fee"];
//# sourceMappingURL=payable.js.map